import { NFT, ThirdwebClient, getContract } from "thirdweb";
import { TokenStandart } from "../TokenStandart";
import { Web3Config } from "../config/Web3Config";
import { getOwnedNFTs as getOwnedERC721 } from "thirdweb/extensions/erc721";
import { getOwnedNFTs as getOwnedERC1155 } from "thirdweb/extensions/erc1155";
import { ILogger } from "../../cityversetycoon/logger/ILogger";

type OwnedNfts = Array<NFT & { quantityOwned?: bigint }>;

export class NFTCollectionsHelper {
    private static readonly UPDATE_ATTEMPS = 2;

    public constructor(
        private readonly web3Config: Web3Config,
        private readonly client: ThirdwebClient,
        private readonly logger: ILogger
    ) {
    }

    public async getBuildings(address: string): Promise<OwnedNfts> {
        return await this.wrapGetOperation(() => {
            return this.getNFT(address, this.web3Config.buildingCollectionAddress, TokenStandart.ERC721);
        });
    }

    public async getPackages(address: string): Promise<OwnedNfts> {
        return await this.wrapGetOperation(() => {
            return this.getNFT(address, this.web3Config.packagesCollectionAddress, TokenStandart.ERC1155);
        });
    }

    public async getGiftPackages(address: string): Promise<OwnedNfts> {
        return await this.wrapGetOperation(() => {
            return this.getNFT(address, this.web3Config.giftPackagesCollectionAddress, TokenStandart.ERC1155);
        });
    }

    private async getNFT(ownerAddress: string, collectionAddress: string, tokenStandart: TokenStandart): Promise<OwnedNfts> {
        const contract = getContract({
            client: this.client,
            address: collectionAddress,
            chain: this.web3Config.targetChain
        });

        switch (tokenStandart) {
            case TokenStandart.ERC721:
                return await getOwnedERC721({ contract, owner: ownerAddress });
            case TokenStandart.ERC1155:
                return await getOwnedERC1155({ contract, address: ownerAddress });
            default:
                return [];
        }
    }

    private async wrapGetOperation(operation: () => Promise<OwnedNfts>, attemp: number = 0): Promise<OwnedNfts> {
        try {
            return await operation();
        }
        catch (e: unknown) {
            if (attemp < NFTCollectionsHelper.UPDATE_ATTEMPS) {
                return await this.wrapGetOperation(operation, ++attemp);
            }
            this.logger.error("Exception on get nfts from collection: ", e);
            return null;
        }
    }
}